/* eslint-disable no-unused-expressions */
import { FormEvent, useState, ChangeEvent, useEffect } from 'react';
import { trackEvent } from 'services/Gtm/functions';
import { EventData } from 'services/Gtm/entities';
import useDebounce from 'hooks/useDebounce';
import * as S from './SearchStyles';
import Button from '../Base/Button';

interface Props {
  value: string;
  className?: string;
  trackingData: EventData;
  onSearch: (value: string) => void;
  onInput: (value: string) => void;
  dataCy?: string;
}

const Search = ({ value, className, trackingData, onSearch, onInput, dataCy }: Props) => {
  const [inputValue, setInputValue] = useState(value);
  const debouncedInputValue = useDebounce(inputValue, 500);

  useEffect(() => {
    onSearch(inputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedInputValue]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInput = (e: FormEvent<HTMLFormElement>) => onInput((e.target as HTMLInputElement).value);

  const btnSize = className?.includes('sm') ? 'small' : 'large';

  return (
    <S.Wrapper className={className}>
      <form
        aria-label='Search for articles'
        onInput={handleInput}
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <S.SearchInput
          placeholder='Search Fortune...'
          className={btnSize}
          value={inputValue}
          name='search'
          data-cy={dataCy}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setInputValue(e.target.value)}
        />
        <Button
          onClick={() => {
            trackEvent &&
              trackEvent({
                ...trackingData,
                contentPlacementCD: 'top of grid search',
                eventAction: 'search',
                eventLabel: 'search started',
              });
          }}
          className='search-button'
          variant='primary'
          size={{ default: btnSize }}
          hasRightArrow={false}
          dataCy={`${dataCy}-action`}
        >
          Search
        </Button>
      </form>
    </S.Wrapper>
  );
};

export default Search;
